/*
 * @Author: Kuaiyin FE
 * @Date: 2020-07-08 22:00:39
 * @Description: iOS 桥接方法
 * @FilePath: /kuaiyin-h5/src/sdk/ios_sdk.js
 */
const userInfo = require('./user-info.json');

// iOS 桥接方法使用第三方框架 DSBridge（ https://github.com/wendux/DSBridge-IOS ）
import dsBridge from 'dsbridge';

/**
 * @description: 定义IOS监听方法常量
 */

const iosMethodObj = {
	ON_SHOW: 'onShow',
	ON_HIDDEN: 'onHidden',
	ON_REWARD_VIDEO_PLAYED: 'onRewardVideoPlayEnd',
	ON_MUSIC_ACTION: 'onMusicAction',
	ON_CALENDAR_CALLBACK: 'onCalendarCallBack',
	ON_RECHARGE_CALLBACK: 'onRechargeCallback',
	ON_PAY_RESULT: 'onPayResult', // 支付完成回调事件
};

/**
 * @description: 定义IOS bridge原生方法名
 */
const iosAppCallObj = {
	IS_CALENDAR_ENABLED: 'isCalendarEnabled',
	HANDLE_CALENDAR: 'callCalendar',
	OPEN_PAGE_WITH_JSON: 'openPageWithJSON',
	TOAST: 'toast',
	COPY: 'copy',
	SHARE_TO: 'shareInfo',
	SET_TITLE: 'setTitle',
	CLOSE_WEBVIEW: 'closeWebView',
	GET_USER_INFO: 'getUserInfo',
	SHOW_REWARD_VIDEO_AD_WITH_JSON: 'showRewardVideoAdWithJSON',
	INIT_MUSIC_PLAYER_LIST: 'setMusicList',
	APPEND_MUSIC_PLAYER_LIST: 'appendMusicList',
	HANDLE_MUSIC_BY_ACTION: 'h5MusicAction',
	UPLOAD_OPUS: 'uploadOpus',
	IS_NOTIFICATION_ENABLED: 'isNotificationEnabled',
	OPEN_NOTIFICATION: 'openNotification',
	PAUSE_MUSIC: 'pauseMusic',
	SIGN_CONTENT: 'signContent',
	OPEN_NATIVE_PAGE: 'openNativePage',
	LAUNCH_APP_DETAILS_SETTINGS: 'launchAppDetailsSettings',
	REFRESH_TOKEN: 'refreshToken',
	BROWSER: 'browser',
	LIVE_RECHARGE: 'liveRecharge',
	VIP_RECHARGE: 'vipRecharge',
};

/**
 * @description: ios桥接对象注册事件回调方法
 * @param {string} event - 时间名称
 * @param {object} callback - 回调函数
 * @return: void
 */

const iosRegister = (event, callback) => {
	try {
		const eventStr = iosMethodObj[event];

		if (eventStr) {
			dsBridge.register(eventStr, callback);
		}
	} catch (e) {
		console.log(e);
	}
};

/**
 * @description: js调用ios bridge原生方法
 * @param {string} appFn - 方法名
 * @param {string} param - 参数
 * @return: void
 */

const iosAppCall = (appFn, ...param) => {
	console.log(`iosAppCall`, appFn);
	try {
		const fnStr = iosAppCallObj[appFn];

		// if (process.env.NODE_ENV === 'development') {
		// 	return handleNoBridge(fnStr, ...param);
		// } else {
		return dsBridge.call(fnStr, ...param);
		// }
	} catch (e) {
		console.log(e);
	}
};

/**
 * @description: 处理没有 bridge 的情况
 * @param {string} funcName - 方法名
 * @param {string} param - 参数
 */

const handleNoBridge = (funcName, ...param) => {
	console.log(`ios handleNoBridge`, funcName);
	switch (funcName) {
		case 'openPageWithJSON':
			window.location.href = JSON.parse(param).url;
			break;
		case 'getUserInfo':
			if (process.env.NODE_ENV === 'development') {
				// TODO ！！上线时打开！！
				return JSON.stringify(userInfo);
			}
			break;
		case 'signContent':
			break;
		case 'setTitle':
			if (process.env.NODE_ENV === 'development') {
				window.document.title = param;
			}
			break;
		default:
			throw Error('bridge is not defined!');
	}
};
export { iosRegister, iosAppCall };



// WEBPACK FOOTER //
// ./src/sdk/ios_sdk.js